import React from 'react';
import { FormInstance } from 'antd/es/form';

const IssueTreeTypeAnswer = ({ form }: { form: FormInstance }) => {
  return <div>IssueTreeTypeAnswer</div>;
};

export default IssueTreeTypeAnswer;
